var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('image-entity-slideshow');
import { breakpoints, theme } from '@shapeable/theme';
import { ImageEntityBackground } from './image-entity-background';
import { useReady } from '../hooks/use-ready';
import { get, each, first } from 'lodash';
import { SlideControls } from '../elements/slide-controls';
import { useSwipeable } from 'react-swipeable';
import { ImageEntityInfoTooltip } from './image-entity-info-tooltip';
import ReactTooltip from 'react-tooltip';
export var ImageEntitySlideshowDefaultProps = {
  slideInterval: 5000,
  initialIndex: 0,
  preload: true,
  fadeColor: '#000000',
  fadeDuration: 300,
  showSlideControls: true,
  slideStyle: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var FadeStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 100%;\n    display: flex;\n    width: 100%;\n    background: #005D2500;\n\n    ", "\n    ", "\n  "], ["\n    height: 100%;\n    display: flex;\n    width: 100%;\n    background: #005D2500;\n\n    ", "\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
      durationInSeconds = _a.durationInSeconds;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      transition: background-color ", "s;\n      background: ", "00;\n    "], ["\n      transition: background-color ", "s;\n      background: ", "00;\n    "])), durationInSeconds, _color);
  }, function (_a) {
    var isOn = _a.isOn,
      _color = _a._color;
    return isOn && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background: ", "FF;\n    "], ["\n      background: ", "FF;\n    "])), _color);
  })
});
var BannerTitlesStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-grow: 1;\n    color: #FFF;\n    display: flex;\n    justify-self: stretch;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding: ", " ", ";\n\n    \n  "], ["\n    flex-grow: 1;\n    color: #FFF;\n    display: flex;\n    justify-self: stretch;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding: ", " ", ";\n\n    \n  "])), theme.UNIT(8), theme.UNIT(4))
});
var SlideControlsStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    bottom: ", ";\n    width: 100%;\n  "], ["\n    position: absolute;\n    bottom: ", ";\n    width: 100%;\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    bottom: ", ";\n  "], ["\n    bottom: ", ";\n  "])), theme.UNIT(5))
});
var InfoTooltipStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    position: absolute;\n    right: ", ";\n    bottom: ", ";\n    z-index: 200;\n  "], ["\n    position: absolute;\n    right: ", ";\n    bottom: ", ";\n    z-index: 200;\n  "])), theme.UNIT(5), theme.UNIT(5)),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    right: ", ";\n    bottom: ", ";\n  "], ["\n    right: ", ";\n    bottom: ", ";\n  "])), theme.UNIT(6), theme.UNIT(6)),
  desktop: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    right: ", ";\n    bottom: ", ";\n  "], ["\n    right: ", ";\n    bottom: ", ";\n  "])), theme.UNIT(6), theme.UNIT(6))
});
// -------- Components -------->
var My = {
  Container: styled(ImageEntityBackground)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Fade: styled.div.attrs(cls.attr('fade'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles),
  BannerTitles: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BannerTitlesStyles),
  SlideControls: styled(SlideControls)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), SlideControlsStyles),
  InfoTooltip: styled(ImageEntityInfoTooltip).attrs(cls.attr('info-tooltip'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), InfoTooltipStyles)
};
var _images = [];
export var ImageEntitySlideshow = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    _b = props.items,
    items = _b === void 0 ? [] : _b,
    fadeDuration = props.fadeDuration,
    slideInterval = props.slideInterval,
    _c = props.infoTooltipProps,
    infoTooltipProps = _c === void 0 ? {} : _c,
    showInfo = props.showInfo,
    fadeColor = props.fadeColor,
    preload = props.preload,
    slideStyle = props.slideStyle,
    overlayColor = props.overlayColor,
    aspectRatio = props.aspectRatio,
    slideControls = props.slideControls;
  var _d = __read(useState(0), 2),
    itemIndex = _d[0],
    setItemIndex = _d[1];
  var _e = __read(useState(false), 2),
    fade = _e[0],
    setFade = _e[1];
  var isReady = useReady().isReady;
  var showSlideControls = items.length > 1 && props.showSlideControls;
  var showImage = function (index) {
    setFade(true);
    ReactTooltip.rebuild();
    setTimeout(function () {
      setItemIndex(index);
    }, fadeDuration);
    setTimeout(function () {
      setFade(false);
    }, fadeDuration + 1);
  };
  var next = function () {
    var newIndex = itemIndex === items.length - 1 ? 0 : itemIndex + 1;
    showImage(newIndex);
  };
  var prev = function () {
    var newIndex = itemIndex === 0 ? items.length - 1 : itemIndex - 1;
    showImage(newIndex);
  };
  // console.log(items)
  useEffect(function () {
    if (preload) {
      // preload images
      each(items, function (image) {
        var img = new Image();
        var url = get(image, 'image.url');
        img.src = url;
        _images.push(img);
      });
    }
  }, []);
  var handlers = useSwipeable({
    onSwipedLeft: function (eventData) {
      next();
    },
    onSwipedRight: function (eventData) {
      prev();
    }
  });
  useEffect(function () {
    if (isReady && items.length > 1) {
      var intervalId_1 = setInterval(next, slideInterval);
      return function () {
        return clearInterval(intervalId_1);
      };
    }
  }, [itemIndex, isReady]);
  var banner = get(items, "[".concat(itemIndex, "]"), first(items));
  var backgroundImage = (_a = banner === null || banner === void 0 ? void 0 : banner.backgroundImages) === null || _a === void 0 ? void 0 : _a.image.url;
  var hasBannerTitle = true;
  return React.createElement("div", __assign({}, handlers, {
    style: {
      width: '100%'
    },
    className: cls.sub('swipeable')
  }), React.createElement(My.Container, {
    className: cls.name(className),
    overlayColor: overlayColor,
    aspectRatio: aspectRatio,
    entity: {
      image: {
        url: backgroundImage
      }
    }
  }, React.createElement(My.Fade, {
    _color: fadeColor,
    isOn: fade,
    durationInSeconds: fadeDuration / 1000
  }, hasBannerTitle && React.createElement(My.BannerTitles, null, React.createElement("p", null, banner.pretitle), React.createElement("h1", null, banner.name), React.createElement("h4", null, banner.subtitle)), children, showSlideControls && isReady && React.createElement(My.SlideControls, {
    index: itemIndex,
    count: items.length,
    onPrev: prev,
    onNext: next,
    onSelect: showImage,
    style: slideStyle,
    showNavigationButtons: slideControls === null || slideControls === void 0 ? void 0 : slideControls.showNavigationButtons,
    variant: slideControls === null || slideControls === void 0 ? void 0 : slideControls.variant
  })), showInfo && React.createElement(My.InfoTooltip, __assign({
    entity: banner
  }, infoTooltipProps))));
};
ImageEntitySlideshow.defaultProps = ImageEntitySlideshowDefaultProps;
ImageEntitySlideshow.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;